module.exports = __webpack_public_path__ + "img/syfx.364943bd.png";